import { render, staticRenderFns } from "./Sparing.vue?vue&type=template&id=58c4e6ee&"
import script from "./Sparing.vue?vue&type=script&lang=js&"
export * from "./Sparing.vue?vue&type=script&lang=js&"
import style0 from "./Sparing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports